import React from "react";
import { connect } from "react-redux";
import { getPOLineItems } from "../Actions/POViewAPI";
import {
  Button,
  Popover,
  PopoverHeader,
  PopoverBody,
  UncontrolledPopover,
} from "reactstrap";
import Moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import API from "../helpers/api";
import { DownloadDocument } from "../Actions/CommonAPI";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";

class CheckUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      IHMYes: false,
      IHMNo: false,
      keywords: "",
      PoConfirmation: {
        shipId: 0,
        purchaseOrderId: 0,
        poLineItemId: 0,
        ihmPresence: false,
        collectMdocSdoc: false,
        notApplicable: false,
        addKeyWords: false,
        keyword: [],
        modifiedBy: "",
        AddAll: false,
      },
      EditAll: false,
      taskType: "inventory",
    };
    this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.checkBoxClick = this.checkBoxClick.bind(this);
    this.ConfirmPO = this.ConfirmPO.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { poid } = params;
    dispatch({
      type: "SubBannerTitle",
      data: "INVENTORY OF HAZARDOUS MATERIALS",
    });
    if (poid !== "") {
      dispatch(getPOLineItems(poid, this.state.taskType));
    }
  }

  handleRadioButtonChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "IHMYes") {
      this.state.PoConfirmation.notApplicable = false;
      this.state.PoConfirmation.collectMdocSdoc = false;
      this.state.PoConfirmation.ihmPresence = true;
      this.setState({
        IHMYes: true,
        IHMNo: false,
      });
    } else if (nodeName === "IHMNo") {
      this.state.PoConfirmation.notApplicable = false;
      this.state.PoConfirmation.collectMdocSdoc = false;
      this.state.PoConfirmation.ihmPresence = false;
      this.setState({
        IHMYes: false,
        IHMNo: true,
      });
    } else if (nodeName === "notApplicable") {
      this.state.PoConfirmation.notApplicable = true;
      this.state.PoConfirmation.collectMdocSdoc = false;
      this.setState({
        IHMYes: false,
        IHMNo: false,
      });
    } else if (nodeName === "collectMdocSdoc") {
      this.state.PoConfirmation.notApplicable = false;
      this.state.PoConfirmation.collectMdocSdoc = true;
      this.setState({
        IHMYes: false,
        IHMNo: false,
      });
    }
  }

  handleInputChange(e) {
    // this.state.keywords=e.target.value;
    this.state.PoConfirmation.keyword = [e.target.value];
    this.setState({ keywords: e.target.value });
  }

  checkBoxClick(e) {
    let checked = this.state.isChecked;
    if (e.target.checked) {
      checked = true;
    } else {
      checked = false;
    }
    this.state.PoConfirmation.addKeyWords = checked;
    this.setState({});
  }

  ConfirmPO(item) {
    const { dispatch, match } = this.props;
    confirmAlert({
      message: "Are you sure want to add?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let url = `${API.AddAll}?PoLineItemId=${item.poLineItemId}&PurchaseOrderId=${item.purchaseOrderId}&AddAll=${this.state.PoConfirmation.AddAll}`;
            axios
              .put(url)
              .then((response) => {
                dispatch(
                  getPOLineItems(match.params.poid, this.state.taskType)
                );
                toast.success("Po Added successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                dispatch({
                  type: "POAddedSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "POAddedFailure",
                  error: "ERROR",
                });
              });

            //  dispatch(UpdatePOConfirmation(this.state.PoConfirmation));
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }

  confirmAll = (item) => {
    const { dispatch, match } = this.props;
    confirmAlert({
      message: "Are you sure want to add?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.PoConfirmation.AddAll = true;
            let url = `${API.AddAll}?PurchaseOrderId=${item.purchaseOrderId}&AddAll=${this.state.PoConfirmation.AddAll}`;
            axios
              .put(url)
              .then((response) => {
                dispatch(
                  getPOLineItems(match.params.poid, this.state.taskType)
                );
                toast.success("Po Added successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                dispatch({
                  type: "POAddedSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "POAddedFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  hideSidePanels = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  render() {
    const { PODetail, editPOView, POLineItems } = this.props;

    return (
      <div className="full-height px-4 pb-4">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-0"
          onClick={() => this.hideSidePanels()}
        >
          &larr; Back
        </button>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div
              className="card MM-card-header"
              style={{ backgroundColor: "white" }}
            >
              <div className="card-body">
                <h5
                  className="card-title ml-2 mt-2"
                  style={{ color: "092a51" }}
                >
                  Line Items
                </h5>
              </div>
            </div>
            <div className="p-0">
              <div className="row">
                <div className="col-md-12">{this.renderLineItemCard()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLineItemCard() {
    const { editPOView, POLineItems } = this.props;
    return POLineItems && POLineItems.length ? (
      POLineItems.map((item, index) => {
        return (
          <>
            <div
              className="card"
              style={{
                overflow: "hidden",
                position: "relative",
                marginBottom: "5px",
              }}
            >
              {/* <div className="arrow-left-red"></div> */}
              {item.ihmPresence == "Yes" || item.ihmPresence ? (
                <div className="arrow-left-red"></div>
              ) : (
                <div className="arrow-left-green"></div>
              )}
              <div className="px-4 py-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-2 py-1">
                          <span>
                            <strong>Serial No : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.poLineItemId}
                            </span>
                          </span>
                        </div>
                        <div className="col-md-2 py-1">
                          <span>
                            <strong>Qty : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">{item.quantity}</span>
                          </span>
                        </div>
                        <div className="col-md-2 py-1">
                          <span>
                            <strong>Unit : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">{item.units}</span>
                          </span>
                        </div>
                        <div className="col-md-3 py-1">
                          <span>
                            <strong>Part No/Drawing No : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">{item.partNo}</span>
                          </span>
                        </div>
                        <div className="col-md-3 py-1 mb-2">
                          <span>
                            <strong>IHM Presense : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont mr-3">
                              {item.isPCHM
                                ? "PCHM"
                                : item.ihmPresence
                                  ? "Yes"
                                  : "No"}
                            </span>
                          </span>
                        </div>
                        <div className="col-md-2 py-1">
                          <span>
                            <strong>SDoC : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.sdocAttachmentName}
                            </span>
                            {item.sdocAttachmentName ? (
                              <i
                                class="fa fa-download click ml-1"
                                onClick={() =>
                                  this.downloadAttachment(
                                    item.sdocAttachmentName,
                                    item.sdocAttachmentGuid
                                  )
                                }
                              ></i>
                            ) : null}
                          </span>
                        </div>
                        <div className="col-md-2 py-1">
                          <span>
                            <strong>MD : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.mdocAttachmentName}
                            </span>
                            {item.mdocAttachmentName ? (
                              <i
                                class="fa fa-download click ml-1"
                                onClick={() =>
                                  this.downloadAttachment(
                                    item.mdocAttachmentName,
                                    item.mdocAttachmentGuid
                                  )
                                }
                              ></i>
                            ) : null}
                          </span>
                        </div>
                        <div className="col-md-5 py-1">
                          <span>
                            <strong>Item Description : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.itemDescription}
                            </span>
                          </span>
                        </div>
                        <div className="col-md-2 py-1 mb-2">
                          <span>
                            <strong>Comments : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">{item.comments}</span>
                          </span>
                        </div>
                        <div className="col-md-3 py-1 mb-2">
                          <span>
                            <strong>Designated Person Rank : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.designatedPersonRank ?? ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-md-3 py-1 mb-2">
                          <span>
                            <strong>Designated Person Name : </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="italicFont">
                              {item.designatedPersonName ?? ""}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <div className="panel-box">
                            <div
                              className="card MM-card-header"
                              style={{
                                backgroundColor: "white",
                                marginBottom: 0,
                              }}
                            >
                              <div style={{ backgroundColor: "darkgray" }}>
                                <h5
                                  className="card-title ml-2 mt-1 mb-1"
                                  style={{ color: "092a51" }}
                                >
                                  Used Material Updates
                                </h5>
                              </div>
                            </div>
                            <div className="py-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className={"col-sm-12"}>
                                    <div className="row mx-2 my-1">
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>Quantity Used : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                .quantityUsed
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>Quantity Removed : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                .quantityRemoved
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>Location Used : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                .locationUsed
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3 mb-2">
                                        <span>
                                          <strong>Location Removed : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                .locationRemoved
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3 mb-2">
                                        <span>
                                          <strong>Equipment : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                ?.equipment ?? ""
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3 mb-2">
                                        <span>
                                          <strong>Deck : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                ?.deck ?? ""
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3 mb-2">
                                        <span>
                                          <strong>Installation Date : </strong>
                                          <span className="lato">
                                            {
                                              item.usedMaterialUpdates
                                                ?.installationDate ?
                                                moment(item.usedMaterialUpdates?.installationDate).format("YYYY-MM-DD h:mm A")
                                                : ''
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>Comments : </strong>
                                          <span className="lato">
                                            {item.usedMaterialUpdates.comments}
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>
                                            Designated Person Rank :{" "}
                                          </strong>
                                          <span className="lato">
                                            {item.usedMaterialUpdates
                                              ?.designatedPersonRank ?? ""}
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>
                                            Designated Person Name :{" "}
                                          </strong>
                                          <span className="lato">
                                            {item.usedMaterialUpdates
                                              ?.designatedPersonName ?? ""}
                                          </span>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span>
                                          <strong>Doc : </strong>
                                          <i aria-hidden="true"></i>{" "}
                                          <span className="italicFont">
                                            {
                                              item.usedMaterialUpdates
                                                .attachmentName
                                            }
                                          </span>
                                          {item.usedMaterialUpdates
                                            .attachmentName ? (
                                            <span>
                                              <i
                                                class="fa fa-download click ml-1"
                                                onClick={() =>
                                                  this.downloadAttachment(
                                                    item.usedMaterialUpdates
                                                      .attachmentName,
                                                    item.usedMaterialUpdates
                                                      .attachmentGuid
                                                  )
                                                }
                                              ></i>
                                            </span>
                                          ) : null}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">No Items</h6>
        </div>
      </div>
    );
  }
  downloadAttachment = (FileName, Guid) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(FileName, Guid));
  };
}

function mapStateToProps(state) {
  return {
    //BY BALU MOORTHI
    PODetail: state.POViewReducer.PODetail,
    POLineItems: state.POViewReducer.POLineItems,
    editPOView: state.SidePanReducer.EditPOView || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckUpdate);
